import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { IComboGroupPositionItem } from 'types';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IComboGroupPositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const comboGroupRowClasses = classNames(style.comboGroup, style.row);
	const comboGroupNameClasses = classNames(style.comboGroupName);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	return (
		<div className={containerClasses}>
			<div className={comboGroupRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<Text
					className={comboGroupNameClasses}
					translationNameSpace="listing"
					translationKey={data.name}
					withTooltip={true}
				/>
			</div>
			<div className={restaurantRowClasses}>
				<RestaurantsList restaurants={restaurants} />
			</div>
			<Text
				className={customerRowClasses}
				translationNameSpace="listing"
				translationKey={data.customer.name}
				withTooltip={true}
			/>
		</div>
	);
};

export default Item;
